import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './ProductsPmsHeader.css';

function ProductsPsHeader() {
    const { t } = useTranslation();

    return (
        <div className='product-header' style={{ backgroundImage: 'url(/images/products-ps-header.png)' }}>
            <div className='page-content d-flex align-items-center'>
                <div className='col-6 d-flex flex-column'>
                    <div className='chip-blue'>
                        {t('Smart POS Built for Hospitality')}
                    </div>
                    <h1>{t('Point of Sale System for Hotels, Resorts & Restaurants')}</h1>
                    <p className='body-large'>
                        {t('Tableview is the native POS system fully integrated with Prostay—built specifically for the needs of hotels, resorts, and food & beverage outlets. From poolside service to in-room dining, Tableview gives your staff the tools to take orders, send them to the kitchen, charge to rooms, and manage transactions—all in real time.')}
                    </p>
                </div>
                <div className='col img-wrapper'>
                    <img src='/images/posheader.svg' alt={"Room planning"}/>
                </div>
            </div>
        </div>
    );
}

export default ProductsPsHeader;
